module.exports = __webpack_public_path__ + "static/img/4.1a3c286.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jzsg/4.png
// module id = 6kDN
// module chunks = 0